type Listener = () => void;

/** Lets the API client (which knows nothing about React) tell the app that the session is gone. */
export class SessionEvents {
  private listeners = new Set<Listener>();

  onExpired(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  expire(): void {
    for (const listener of [...this.listeners]) listener();
  }
}
